// Modules
import React from "react";
//@ts-ignore
import { LocalizationContext } from "react-localize";
// Styles
import "./GuestProfile.sass";
// Services

// Interfaces

// Components
// import MvLoader from "Generic/MvLoader/MvLoader";
import ToolTip from "Generic/ToolTip";
import { Tip } from "Interfaces/TipInterface";
import { MvModal } from "../../../Generic/MvModal";
import MvLink from "Generic/MvLink";
import { ModifyPrimaryGuestProfile } from "./ModifyPrimaryGuestProfile";
import { PrimaryGuest } from "Interfaces/BookResort";
import ReservationService from "Services/reservation.service";
import { GetCountriesResult, ReservationType } from "Interfaces/GetReservations";
import { ReactAppMode } from "Interfaces/ReactAppModes";
import { EXEC_MODE } from "cfg";
import moment from "moment";
import { MvArrivingGuestInfoAlertModal} from "Generic/MvModal/MvArrivingGuestInfoAlertModal/MvArrivingGuestInfoAlertModal";
import { trackAnalyticData } from "Utils/analytics";
import { SiteType } from "Interfaces/AYPResultInterface";

// Utils

// Constants

// @ts-ignore
// import sessionStorage from "store/storages/sessionStorage";

type Props = {
  guest: any;
  readOnly: boolean;
  updateGuestProfile?: (data: PrimaryGuest) => void;
  showPrimaryGuest?: boolean;
  updateEditStatus?: (status: boolean) => void;
  resType?: any;
  resID?: number; //This was added here for modifying the guest info MVC-717, MVC-718
  reservationCheckIn?: string | Date;
  reservationType?: string;
  reservationInformation?: any;
};

type GuestProfileState = {
  editGuestProfile: boolean,
  formValues: any;
  formErrors: any;
  countriesList: GetCountriesResult[];
  isStateRequired: boolean;
  stateUniqueKey : any;
  isZipCodeRequired: boolean;
  isFormEdit?: boolean;
  savedFormValues: any;
  defaultFormValues: any;
  alertPopup: boolean;
};

const InitState: GuestProfileState = {
  editGuestProfile: false,
  formValues: {},
  formErrors: {},
  countriesList: [],
  isStateRequired: true,
  stateUniqueKey: {},
  isZipCodeRequired: false,
  isFormEdit: false,
  savedFormValues: {},
  defaultFormValues: {},
  alertPopup: false
};

class GuestProfile extends React.Component<Props, GuestProfileState> {
  emailTip: [Tip] = [
    {
      label: "",
      desc: "static.content.sr-email-tooltip",
    },
  ];
  bonvoyTip: [Tip] = [
    {
      label: "",
      desc: "static.content.sr-bonvoy-tooltip",
    },
  ];
  constructor(props: Readonly<Props>) {
    super(props);

    this.state = Object.assign({}, InitState);
  }

  componentDidMount() {
    const reservationService = new ReservationService();
    reservationService.getCountries().then((response: GetCountriesResult[]) => {
      this.setState({ countriesList: response });
    });
  }

  componentDidUpdate(prevProps: Props, prevState: any) {
    if (prevProps.guest !== this.props.guest) {
      const { firstName, lastName, address, phone, email, memberships } = this.props.guest;
      let initialAddress = {};
      if (address) {
        const { addressLine1, addressLine2, addressLine3, city, state, stateDescription, country, countryDescription, postalCode, stateProvince } = address;
        initialAddress = { addressLine1, addressLine2, addressLine3, city, state, stateDescription, country, countryDescription, postalCode, stateProvince };
      }
      let initialPhone = {}
      if (phone) {
        const { code, phoneNumber } = phone;
        const nullCheckCode = code ? code : ''; //checking to see if code is null
        initialPhone = { nullCheckCode, phoneNumber };
      }
      const membershipId = (memberships && memberships.length) && memberships[0].membershipId !== null ? memberships[0].membershipId : ""
      const { addressLine1, addressLine2, addressLine3, city, state, stateDescription, country, countryDescription, postalCode, stateProvince } = initialAddress as any;
      const { phoneNumber, nullCheckCode } = initialPhone as any;
      const payload = {
        firstName: firstName,
        lastName: lastName,
        addressLine1: addressLine1,
        addressLine2: addressLine2 || '',
        addressLine3: addressLine3 || '',
        country: Number(country || 1),
        city: city,
        countryDescription: countryDescription || '',
        state: Number(state || -1),
        stateDescription: stateDescription,
        phoneNumber: nullCheckCode + '' + phoneNumber,
        bonvoyNumber: membershipId,
        email: email,
        postalCode: postalCode,
      } as PrimaryGuest;
      if (this.props.updateGuestProfile) {
        this.props.updateGuestProfile(payload);
      }
    }
    else if ( prevState.stateUniqueKey !== this.state.stateUniqueKey) {
      const { firstName, lastName, address, phone, email, memberships } = this.props.guest;
      let initialAddress = {};
      if (address) {
        const { addressLine1, addressLine2, addressLine3, city, state, stateDescription, country, countryDescription, postalCode, stateProvince } = address;
        initialAddress = { addressLine1, addressLine2, addressLine3, city, state, stateDescription, country, countryDescription, postalCode, stateProvince };
      }
      let initialPhone = {}
      if (phone) {
        const { code, phoneNumber } = phone;
        const nullCheckCode = code ? code : ''; //checking to see if code is null
        initialPhone = { nullCheckCode, phoneNumber };
      }
      const membershipId = (memberships && memberships.length) && memberships[0].membershipId !== null ? memberships[0].membershipId : ""
      const { addressLine1, addressLine2, addressLine3, city, state, stateDescription, country, countryDescription, postalCode, stateProvince } = initialAddress as any;
      const { phoneNumber, nullCheckCode } = initialPhone as any;
      const payload = {
        firstName: firstName,
        lastName: lastName,
        addressLine1: addressLine1,
        addressLine2: addressLine2 || '',
        addressLine3: addressLine3 || '',
        country: Number(country || 1),
        city: city,
        countryDescription: countryDescription || '',
        state: Number(this.state.stateUniqueKey || -1),
        stateDescription: stateProvince,
        phoneNumber: nullCheckCode + '' + phoneNumber,
        bonvoyNumber: membershipId,
        email: email,
        postalCode: postalCode,
      } as PrimaryGuest;
      if (this.props.updateGuestProfile) {
        this.props.updateGuestProfile(payload);
      }
    }
  }

  setIsStateRequired = (isRequired: boolean) => {
    this.setState({ isStateRequired: isRequired });
  }

  setStateUniqueKey = (key: any) => {
    this.setState({ stateUniqueKey: key});
  }

  setIsZipCodeRequired = (isRequired: boolean) => {
    this.setState({ isZipCodeRequired: isRequired });
  }

  updateGuestProfile = () => {
    const { firstName, lastName, addressLine1, addressLine2, addressLine3, country, countryDescription, city, state, stateDescription, email, postalCode, phoneNumber, bonvoyNumber } = this.state.formValues;
    let isValid = true
    const errors = {} as any;
    if (!this.validateTextValues(firstName)) {
      isValid = false
      errors['firstName'] = true
    }
    if (!this.validateTextValues(lastName)) {
      isValid = false
      errors['lastName'] = true
    }
    if (!this.validateTextValues(addressLine1)) {
      isValid = false
      errors['addressLine1'] = true
    }
    if (!this.validateTextValues(city)) {
      isValid = false
      errors['city'] = true
    }
    if (!this.validateTextValues(email)) {
      isValid = false
      errors['email'] = true
    }
    if (!this.validateTextValues(countryDescription)) {
      isValid = false
      errors['country'] = true
    }
    if (this.state.isStateRequired && (!this.validateTextValues(stateDescription) || !this.isValidNumber(state) )){
      isValid = false
      errors['state'] = true
    }
    if (this.validateZipCode()) {
      isValid = false
      errors['postalCode'] = true
    }
    if (this.validatePhoneNumber()) {
      isValid = false
      errors['phoneNumber'] = true
    }
    if (this.validateBonvoyNumber()) {
      isValid = false;
      errors['bonvoyNumber'] = true;
    }
    this.setState({ formErrors: errors });
    if (isValid) {
      const payload = {
        firstName: firstName,
        lastName: lastName,
        addressLine1: addressLine1,
        addressLine2: addressLine2 || '',
        addressLine3: addressLine3 || '',
        country: country,
        city: city,
        countryDescription: countryDescription,
        state: Number(state || -1),
        stateDescription: stateDescription,
        phoneNumber: phoneNumber,
        bonvoyNumber: bonvoyNumber,
        email: email,
        postalCode: postalCode || ''
      } as PrimaryGuest;
      if (this.props.updateGuestProfile) {
        this.props.updateGuestProfile(payload);
      }
      if (this.props.updateEditStatus) { this.props.updateEditStatus(false); }
      this.setState({ editGuestProfile: false, savedFormValues: this.state.formValues, isFormEdit: true })
    }
  }

  validatePhoneNumber = () => {
    const { phoneNumber } = this.state.formValues
    let isError = false;
    if (this.validateTextValues(phoneNumber)) {
      isError = !this.isValidPhoneNumber(phoneNumber)
    }

    return isError;
  }

  validateBonvoyNumber = () => {
    const { bonvoyNumber } = this.state.formValues;
    let isError = false;
    if (this.validateTextValues(bonvoyNumber)) {
      isError = !this.isValidBonvoyNumber(bonvoyNumber);
    }

    return isError;
  }

  validateTextValues = (value: string) => {
    return !!value && !!value.trim();
  }

  isValidPhoneNumber = (pNumber: string) => {
    return (/^[0-9]{1,14}$/.test(pNumber));
  }

  isValidBonvoyNumber = (bonvoyNumber: string) => {
    return (/^[0-9]{9}$/.test(bonvoyNumber));
  }

  isValidNumber = (number: string) => {
    return (/^[1-9]\d*$/.test(number));
  }

  isValidUSZip = (sZip: string) => {
    return (!(/^0*$/.test(sZip)) && !(/^[0-9]{6}$/.test(sZip)) && /^[0-9]{5}(?:-[0-9]{4})?$/.test(sZip)) || (/^[0-9]{9}$/.test(sZip));
  }

  isValidCanadaZip = (sZip: string) => {
    return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(sZip);
  }

  validateZipCode = () => {
    const { country, postalCode } = this.state.formValues
    let isError = false;
    if (this.state.isZipCodeRequired) {
      if (this.validateTextValues(postalCode)) {
        switch (country) {
          case 4: //for USA
            isError = !this.isValidUSZip(postalCode)
            break;
          case 1013: //for Canada
            isError = !this.isValidCanadaZip(postalCode)
            break;
          default:
            break;
        }

      } else {
        isError = true;
      }
    }
    return isError;
  }

  setFormValues = (values: any) => {
    this.setState({ formValues: values })
  }

  setDefaultFormValues = (values: any) => {
    this.setState({ formValues: values, defaultFormValues: values })
  }

  getPhoneDetail = (guest: any) => {
    if (typeof guest.phoneNumber == 'string' && guest.phoneNumber !== 'undefined') {
      return `${guest.phoneNumber}`;
    } else if (typeof guest.phone == 'string' && guest.phone !== 'undefined') {
      return `${guest.phone}`;
    } else if (typeof guest.phone == 'string' && guest.phone !== 'undefined') {
      return guest.phone;
    } else if (typeof guest.phone == 'object') {
      if (guest.phone.code == ! 'null') {
        return `${guest.phone.code} ${guest.phone.phoneNumber}`;
      } else {
        return `${guest.phone.phoneNumber || ''}`
      }
    }
    return '';
  }

  getProfileDetails = () => {
    const { guest } = this.props;
    const { isFormEdit, savedFormValues: formValues } = this.state;
    const { address } = guest;
    const { localize } = this.context;
    const { reservationInformation } = this.props;
    const reservationSiteTypeName = reservationInformation ? reservationInformation.managementCompany.siteType: '';
    const reservationInfoNodeName = reservationInformation ? reservationInformation.managementCompany.nodename: '';
    console.log("this.props......", reservationSiteTypeName, reservationInfoNodeName);

    return isFormEdit ? <div className="inner-container">
      <div className="list-item">
        {localize("static.content.sr-name")}{" "}
        <div className="list-content">
          {" "}
          {formValues.firstName} {formValues.lastName}
        </div>
      </div>{" "}
      <div className="list-item">
        {localize("static.content.sr-address")}
        <div className="list-content">
          {" "}
          {formValues ? <>{formValues.addressLine1}</> : ""}
          {formValues ? <>&nbsp;{formValues.addressLine2}</> : ""}
          {formValues ? <>&nbsp;{formValues.addressLine3}</> : ""}
          {formValues ? <>&nbsp;{formValues.city}</> : ""}
          {formValues ? <>&nbsp;{formValues.stateDescription}</> : ""}
          {formValues ? <>&nbsp;{formValues.postalCode}</> : ""}
          {formValues ? <>&nbsp;{formValues.countryDescription}</> : ""}
        </div>
      </div>{" "}
      <div className="list-item">
        {localize("static.content.sr-phone")}
        <div className="list-content">
          {" "}
          {formValues && this.getPhoneDetail(formValues)}
        </div>
      </div>{" "}
      <div className="list-item">
        {" "}
        <div className='con-tip'><span className='tool-title'>{localize("static.content.sr-email")}</span>{" "}
          <ToolTip useRefToPosition={false} tabIndex={0} tip={this.emailTip} id='guest-profile-email'>
            <span className="question-icon">{"?"}</span>
          </ToolTip>
        </div>
        <div className="list-content">{formValues.email}</div>
      </div>{" "}
      <div className="list-item">
        {" "}
        <div className='con-tip'> <span className='tool-title'>{localize("static.content.sr-bonvoy-number")}</span>{" "}
          <ToolTip useRefToPosition={false} tabIndex={0} tip={this.bonvoyTip} id='guest-profile-bonvoy'>
            <span className="question-icon">{"?"}</span>
          </ToolTip>
        </div>
        <div className="list-content">{formValues ? formValues.bonvoyNumber : ""}</div>
      </div>
    </div> : <div className="inner-container">
      <div className="list-item">
        {localize("static.content.sr-name")}{" "}
        <div className="list-content">
          {" "}
          {guest.firstName} {guest.lastName}
        </div>
      </div>{" "}
      {(reservationSiteTypeName !== SiteType.EXPLORER && reservationInfoNodeName !== 'hopper') &&
      <>
      <div className="list-item">
        {localize("static.content.sr-address")}
        <div className="list-content">
          {" "}
          {address ? <>{address.addressLine1}</> : ""}
          {address ? <>&nbsp;{address.addressLine2}</> : ""}
          {address ? <>&nbsp;{address.addressLine3}</> : ""}
          {address ? <>&nbsp;{address.city}</> : ""}
          {address ? <>&nbsp;{address.stateDescription}</> : ""}
          {address ? <>&nbsp;{address.postalCode}</> : ""}
          {address ? <>&nbsp;{address.countryDescription}</> : ""}
        </div>
      </div>{" "}
      </> }
      <div className="list-item">
        {localize("static.content.sr-phone")}
        <div className="list-content">
          {" "}
          {guest && this.getPhoneDetail(guest)}
        </div>
      </div>{" "}
      <div className="list-item">
        {" "}
        <div className='con-tip'><span className='tool-title'>{localize("static.content.sr-email")}</span>{" "}
          <ToolTip useRefToPosition={false} tabIndex={0} tip={this.emailTip} id='guest-profile-email'>
            <span className="question-icon">{"?"}</span>
          </ToolTip>
        </div>
        <div className="list-content">{guest.email}</div>
      </div>{" "}
      <div className="list-item">
        {" "}
        <div className='con-tip'> <span className='tool-title'>{localize("static.content.sr-bonvoy-number")}</span>{" "}
          <ToolTip useRefToPosition={false} tabIndex={0} tip={this.bonvoyTip} id='guest-profile-bonvoy'>
            <span className="question-icon">{"?"}</span>
          </ToolTip>
        </div>
        <div className="list-content">{(guest.memberships && guest.memberships.length) ? guest.memberships[0].membershipId : ""}</div>
      </div>
    </div>
  }

  getGuestHeader = () => {
    const { localize } = this.context;
    return <div className="guest-header"> {" "} {localize("static.content.sr-guest-header")}</div>
  }

  openChangeArrivalLink = () => {
    // const intMode:any = sessionStorage.getItem('SYSTEM_INTEGRATION_MODE');
    // const ownerIdforReact:any = sessionStorage.getItem('OWNER_NUMBER');
    // const ssoTokenForReact:any = sessionStorage.getItem('EXP_API_TKN');
    const intMode:any = document.getElementById('intMode');
    const ownerIdforReact:any = document.getElementById('ownerIdforReact');
    const ssoTokenForReact:any = document.getElementById('ssoTokenForReact')
    if ([ReactAppMode.VOA, ReactAppMode.LOCAL].includes(EXEC_MODE)){
      const associateEid:any = document.getElementById('associateEid');
      let assEid = '';
      (associateEid && associateEid.value) && (assEid = associateEid.value)
      window.location.href = '/timeshare/mvco/getUpcomingReservation/guestForm?intMode='+intMode.value+'&resId='+this.props.resID+'&ownerId='+ownerIdforReact.value+'&associateEid='+assEid+'&callFrom=points&screenType=ARRIVING_GUEST_INFO#'+ssoTokenForReact.value;
    } else if([ReactAppMode.VCAP].includes(EXEC_MODE)) {
      window.location.href = `/changeArrivingGuestInfoSummary.jsp?resId=${this.props.resID}&callFrom=points`;
    }
    trackAnalyticData('guestNameCta'); 
  }

  isShowAlertPopup = () => {
    const { reservationCheckIn } = this.props;
    var nextDate = moment().add('days', 30);
    if(moment(reservationCheckIn).isAfter(nextDate))
      this.openChangeArrivalLink()
    else
      this.openAlertPopup()
  }

  openAlertPopup = () => {
    this.setState({alertPopup: true})
  }

  render() {
    const { guest, readOnly, showPrimaryGuest = true, resType, reservationCheckIn, reservationType, reservationInformation } = this.props;
    const { address } = guest;
    const { localize } = this.context;
    const { isFormEdit, formValues } = this.state;
    var nextDate = moment().add('days', 30);
    var yesterDayDate = moment().subtract('days', 1);
    const reservationTyp = reservationType ? reservationType : sessionStorage.getItem('reservationType');
    console.log("reservationTyp",resType === ReservationType.UPCOMING, (sessionStorage.getItem('reservationType')));
    return (
      <div className="guest-profile-container">

        <div className="guest-header-container">
          {this.getGuestHeader()}
          {resType === ReservationType.UPCOMING && (moment(reservationCheckIn).isAfter(yesterDayDate)) && reservationTyp == "MVC" &&
            <MvLink label={localize("static.content.sr-change-arriving-guest-info")} onClick={this.isShowAlertPopup} />
          }
          {reservationInformation && <MvArrivingGuestInfoAlertModal
            show={this.state.alertPopup}
            toggle={() => this.setState({ alertPopup: !this.state.alertPopup })}
            reservationInformation={reservationInformation}
            handleRedirect={this.openChangeArrivalLink}
          />}
        </div>

        {showPrimaryGuest && <>
          <div className="guest-subheader">
            {" "}
            <h2>{localize("static.content.sr-primary-guest")}</h2>
            {!readOnly && !this.state.editGuestProfile && <MvLink label={localize("static.content.sr-edit")} onClick={() => { this.setState({ editGuestProfile: true }); if (this.props.updateEditStatus) { this.props.updateEditStatus(true); } }} />}
            {!readOnly && this.state.editGuestProfile && <MvLink label={localize("static.content.sr-save")} onClick={this.updateGuestProfile} />}
            {!readOnly && this.state.editGuestProfile && <MvLink label={localize("static.content.sr-cancel")} onClick={() => { this.setState({ editGuestProfile: false, formValues: this.state.defaultFormValues, formErrors: {} }); if (this.props.updateEditStatus) { this.props.updateEditStatus(false); } }} />}
          </div>
          <div className="inner-container">
            <ModifyPrimaryGuestProfile
              editGuestProfile={this.state.editGuestProfile}
              toggleEdit={() => this.setState({ editGuestProfile: !this.state.editGuestProfile })}
              localize={localize}
              guestDetails={guest}
              formValues={this.state.formValues}
              formErrors={this.state.formErrors}
              setFormValues={this.setFormValues}
              setDefaultFormValues={this.setDefaultFormValues}
              countriesList={this.state.countriesList}
              isStateRequired={this.state.isStateRequired}
              setIsStateRequired={this.setIsStateRequired}
              setStateUniqueKey={this.setStateUniqueKey}
              isZipCodeRequired={this.state.isZipCodeRequired}
              setIsZipCodeRequired={this.setIsZipCodeRequired}
            />
          </div>
          {!this.state.editGuestProfile && this.getProfileDetails()}
        </>}
      </div>
    );
  }
}

GuestProfile.contextType = LocalizationContext;

export default GuestProfile;
